/* eslint-disable no-lone-blocks */
import React, { useState } from "react";
// import { Heading } from "../../../../machinery/styled.components";
import {
  Container,
  LeftSideBar,
  VerticalLine,
  InnerContainer,
  RightContainer,
  InnerRightContainer,
  Card,
  CardInner,
  CardHeading,
  ImagesContainer,
  Img,
  Heading,
  InnerCardContainer,
  InnerCardRightContainer,
  Title,
} from "./styled.components";
import { MobileDropdown } from "./mobiledropDown";
import { useEffect } from "react";
const Events = ({ events }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  const [activeEvent, setActiveEvent] = useState(events[0]?._id);

  const onWindowResize = () => {
    setIsMobile(window.innerWidth <= 575);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);
  return (
    <>
      <Container>
        <InnerContainer>
          {isMobile ? (
            <MobileDropdown events={events} setActiveEvent={setActiveEvent} />
          ) : (
            <LeftSideBar>
              {events.map((_event) => {
                return (
                  <Heading
                    style={{
                      color: `${activeEvent == _event._id ? "#F08700" : ""}`,
                    }}
                    onClick={() => setActiveEvent(_event._id)}
                  >
                    {_event.name}
                  </Heading>
                );
              })}
            </LeftSideBar>
          )}
        </InnerContainer>
        <VerticalLine />
        <RightContainer>
          <InnerRightContainer>
            {events.map((_event) => {
              if (activeEvent == _event._id) {
                return (
                  <>
                    <Card>
                      <CardInner>
                        <InnerCardContainer>
                          <CardHeading>Name:</CardHeading>
                          <CardHeading>Organization:</CardHeading>
                          <CardHeading>Venue:</CardHeading>
                          {/* <CardHeading>Cost:</CardHeading> */}
                        </InnerCardContainer>
                        <InnerCardRightContainer>
                          <Title>{_event.name}</Title>
                          <Title>{_event.organization}</Title>
                          <Title>{_event.venue}</Title>
                          {/* <Title>{_event.amount}</Title> */}
                        </InnerCardRightContainer>
                      </CardInner>
                    </Card>
                    <ImagesContainer>
                      {_event.images.map((img) => {
                        return <Img src={img} alt="img" />;
                      })}
                    </ImagesContainer>
                  </>
                );
              }
            })}
          </InnerRightContainer>
        </RightContainer>
      </Container>
    </>
  );
};

export default Events;
